import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allInterestRegion }) => {
  if (!allInterestRegion) return state;
  return state.merge({ allInterestRegion });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
